// Đăng nhập bằng mã QR (docs/KE_HOACH_DANG_NHAP_QR.md). Mã là đường link `<origin>/qr?c=<code>`: quét bằng camera
// thường của điện thoại cũng mở được màn duyệt. Màn quét trong app chỉ nhận đúng dạng này — không mở link lạ.

const HOSTS = new Set(['shoptrack.vn', 'www.shoptrack.vn'])
const CODE_RE = /^[A-Za-z0-9_-]{20,100}$/

export function qrLoginLink(code: string): string {
  return `${window.location.origin}/qr?c=${encodeURIComponent(code)}`
}

/** Mã đăng nhập trong chuỗi đọc từ QR, hoặc null nếu không phải mã đăng nhập ShopTrack. */
export function parseQrLoginLink(text: string): string | null {
  let u: URL
  try {
    u = new URL(text.trim())
  } catch {
    return null
  }
  const sameSite = u.origin === window.location.origin || (u.protocol === 'https:' && HOSTS.has(u.hostname))
  if (!sameSite || u.pathname.replace(/\/+$/, '') !== '/qr') return null
  const c = u.searchParams.get('c') ?? ''
  return CODE_RE.test(c) ? c : null
}

/** Mã lấy từ ?c= khi mở thẳng link (camera thường của điện thoại). */
export function codeFromSearch(search: string): string | null {
  const c = new URLSearchParams(search).get('c') ?? ''
  return CODE_RE.test(c) ? c : null
}
